import React, { useEffect, useRef } from "react";
import Layout from "../../Layout";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";

export default function DialerPage() {
  const captureEvent = useCaptureEvent();
  const hasTrackedPageViewRef = useRef(false);

  useEffect(() => {
    if (!hasTrackedPageViewRef.current) {
      captureEvent("SET_Dialer_PageView");
      hasTrackedPageViewRef.current = true;
    }
  }, [captureEvent]);

  return (
    <Layout className="pt-0 pb-0">
      <iframe
        src={`${process.env.REACT_APP_DIALER_BASE_URL}`}
        width="100%"
        // height="850px"
        frameBorder="0"
        allow="microphone; camera; autoplay; encrypted-media"
        style={{
          border: "none",
          // borderRadius: "8px",
          background: "transparent",
          height: "100vh"
        }}
      />
    </Layout>
  );
} 